// Language translations for WSFinances
const translations = {
  es: {
    // Auth
    login: "Ingresar",
    register: "Registrarse",
    logout: "Cerrar Sesión",
    email: "Email",
    password: "Contraseña",
    confirmPassword: "Confirmar Contraseña",
    name: "Nombre",
    forgotPassword: "¿Olvidaste tu contraseña?",
    noAccount: "¿No tienes cuenta?",
    hasAccount: "¿Ya tienes cuenta?",
    loginTitle: "Ingresa a tu cuenta para continuar",
    registerTitle: "Completa tus datos para registrarte",
    createAccount: "Crear Cuenta",
    registering: "Registrando...",
    loggingIn: "Ingresando...",
    
    // Verify Email
    verifyEmail: "Verifica tu Email",
    verifyEmailDesc: "Ingresa el código de 6 dígitos enviado a tu correo",
    verifyCode: "Código de Verificación",
    verify: "Verificar Email",
    verifying: "Verificando...",
    resendCode: "¿No recibiste el código? Reenviar",
    resending: "Reenviando...",
    backToLogin: "Volver al login",
    emailVerified: "Email verificado correctamente. Redirigiendo...",
    codeSent: "Código reenviado. Revisa tu email.",
    
    // Forgot Password
    recoverPassword: "Recuperar Contraseña",
    recoverPasswordDesc: "Ingresa tu email para recibir el código de recuperación",
    newPassword: "Nueva Contraseña",
    sendCode: "Enviar Código",
    sending: "Enviando...",
    resetPassword: "Restablecer Contraseña",
    resetting: "Actualizando...",
    passwordReset: "Contraseña actualizada correctamente. Redirigiendo...",
    emailSentIfExists: "Si el email existe, recibirás un código de recuperación.",
    back: "Volver",
    recoveryCode: "Código de Recuperación",
    
    // Dashboard
    dashboard: "Dashboard",
    welcome: "Bienvenido",
    newTransaction: "Nueva Transacción",
    totalBalance: "Balance Total",
    totalIncome: "Ingresos Totales",
    totalExpenses: "Gastos Totales",
    incomeVsExpenses: "Ingresos vs Gastos por Mes",
    expensesByCategory: "Gastos por Categoría",
    recentTransactions: "Transacciones Recientes",
    viewAll: "Ver todas",
    addFirstTransaction: "Añadir primera transacción",
    createMonthlyBudget: "Crear presupuesto mensual",
    realBalanceToday: "Balance real hoy",
    incomeThisMonth: "Ingresos este mes",
    expensesThisMonth: "Gastos este mes",
    availableToSpend: "Disponible para gastar",
    noDataToShow: "No hay datos para mostrar",
    noExpensesRecorded: "No hay gastos registrados",
    noTransactionsRecorded: "No hay transacciones registradas",
    
    // Transactions
    transactions: "Transacciones",
    transactionHistory: "Historial completo de movimientos",
    searchPlaceholder: "Buscar por categoría o descripción...",
    filterByType: "Filtrar por tipo",
    all: "Todos",
    income: "Ingreso",
    expense: "Gasto",
    transfer: "Transferencia",
    transfers: "Transferencias",
    fromAccount: "Cuenta origen",
    toAccount: "Cuenta destino",
    noLinkedAccount: "Sin cuenta",
    selectAccount: "Seleccionar cuenta",
    sameAccountError: "La cuenta origen y destino deben ser diferentes",
    transactionTypeHelp: "Registra un ingreso, gasto o transferencia entre cuentas",
    type: "Tipo",
    category: "Categoría",
    description: "Descripción",
    date: "Fecha",
    amount: "Monto",
    save: "Guardar",
    cancel: "Cancelar",
    deleteConfirm: "¿Estás seguro de eliminar esta transacción?",
    noTransactionsToShow: "No hay transacciones que mostrar",
    
    // Categories
    categories: {
      income: ['Salario', 'Freelance', 'Inversiones', 'Ventas', 'Otros'],
      expense: ['Alimentación', 'Transporte', 'Vivienda', 'Servicios', 'Entretenimiento', 'Salud', 'Educación', 'Otros']
    },
    
    // Settings
    settings: "Configuración",
    settingsDesc: "Gestiona tu cuenta y preferencias",
    accountInfo: "Información de la Cuenta",
    yourInfo: "Tu información personal",
    role: "Rol",
    emailVerifiedLabel: "Email Verificado",
    yes: "Sí",
    no: "No",
    changePassword: "Cambiar Contraseña",
    changePasswordDesc: "Actualiza tu contraseña de acceso",
    currentPassword: "Contraseña Actual",
    updating: "Actualizando...",
    passwordChanged: "Contraseña actualizada correctamente",
    
    // Admin
    adminPanel: "Panel de Admin",
    adminPanelDesc: "Gestiona usuarios y monitorea el sistema",
    totalUsers: "Total Usuarios",
    activeUsers: "Usuarios Activos",
    logins24h: "Logins (24h)",
    databaseData: "Datos en Base de Datos",
    records: "Registros",
    users: "Usuarios",
    registeredUsers: "Usuarios Registrados",
    lastAccess: "Último Acceso",
    actions: "Acciones",
    active: "Activo",
    inactive: "Inactivo",
    never: "Nunca",
    accessLogs: "Registro de Accesos",
    noAccessLogs: "No hay registros de acceso",
    userDetails: "Detalles del Usuario",
    registrationDate: "Fecha de Registro",
    deleteUserConfirm: "¿Estás seguro de eliminar al usuario",
    deleteUserWarning: "Esta acción eliminará también todas sus transacciones y no se puede deshacer.",
    userDeleted: "Usuario eliminado correctamente",
    
    // Sidebar
    financePanel: "Panel de Finanzas",
    connectedAs: "Conectado como",
    accounts: "Cuentas",
    budgets: "Presupuestos",
    goalsAndDebts: "Metas y deudas",
    reports: "Reportes",
    receipts: "Recibos",
    import: "Importar",
    importItau: "Importar",
    adminPanelShort: "Admin Panel",
    
    // Errors
    invalidCredentials: "Credenciales inválidas",
    emailAlreadyRegistered: "Email ya registrado",
    passwordsDontMatch: "Las contraseñas no coinciden",
    passwordTooShort: "La contraseña debe tener al menos 6 caracteres",
    invalidCode: "Código inválido",
    codeExpired: "Código expirado",
    currentPasswordIncorrect: "La contraseña actual es incorrecta",
    
    // Hero
    heroTitle: "Controla tus",
    heroHighlight: "finanzas",
    heroDesc: "Gestiona tus ingresos y gastos de manera inteligente con WSFinances.",
    heroRegisterTitle: "Únete a",
    heroRegisterDesc: "Empieza a tomar control de tu dinero hoy mismo."
  },
  
  en: {
    // Auth
    login: "Login",
    register: "Register",
    logout: "Logout",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    name: "Name",
    forgotPassword: "Forgot your password?",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    loginTitle: "Sign in to your account to continue",
    registerTitle: "Complete your details to register",
    createAccount: "Create Account",
    registering: "Registering...",
    loggingIn: "Signing in...",
    
    // Verify Email
    verifyEmail: "Verify your Email",
    verifyEmailDesc: "Enter the 6-digit code sent to your email",
    verifyCode: "Verification Code",
    verify: "Verify Email",
    verifying: "Verifying...",
    resendCode: "Didn't receive the code? Resend",
    resending: "Resending...",
    backToLogin: "Back to login",
    emailVerified: "Email verified successfully. Redirecting...",
    codeSent: "Code resent. Check your email.",
    
    // Forgot Password
    recoverPassword: "Recover Password",
    recoverPasswordDesc: "Enter your email to receive the recovery code",
    newPassword: "New Password",
    sendCode: "Send Code",
    sending: "Sending...",
    resetPassword: "Reset Password",
    resetting: "Updating...",
    passwordReset: "Password updated successfully. Redirecting...",
    emailSentIfExists: "If the email exists, you will receive a recovery code.",
    back: "Back",
    recoveryCode: "Recovery Code",
    
    // Dashboard
    dashboard: "Dashboard",
    welcome: "Welcome",
    newTransaction: "New Transaction",
    totalBalance: "Total Balance",
    totalIncome: "Total Income",
    totalExpenses: "Total Expenses",
    incomeVsExpenses: "Income vs Expenses by Month",
    expensesByCategory: "Expenses by Category",
    recentTransactions: "Recent Transactions",
    viewAll: "View all",
    addFirstTransaction: "Add first transaction",
    createMonthlyBudget: "Create monthly budget",
    realBalanceToday: "Real balance today",
    incomeThisMonth: "Income this month",
    expensesThisMonth: "Expenses this month",
    availableToSpend: "Available to spend",
    noDataToShow: "No data to show",
    noExpensesRecorded: "No expenses recorded",
    noTransactionsRecorded: "No transactions recorded",
    
    // Transactions
    transactions: "Transactions",
    transactionHistory: "Complete transaction history",
    searchPlaceholder: "Search by category or description...",
    filterByType: "Filter by type",
    all: "All",
    income: "Income",
    expense: "Expense",
    transfer: "Transfer",
    transfers: "Transfers",
    fromAccount: "Source account",
    toAccount: "Destination account",
    noLinkedAccount: "No account",
    selectAccount: "Select account",
    sameAccountError: "Source and destination accounts must be different",
    transactionTypeHelp: "Register income, expense, or a transfer between accounts",
    type: "Type",
    category: "Category",
    description: "Description",
    date: "Date",
    amount: "Amount",
    save: "Save",
    cancel: "Cancel",
    deleteConfirm: "Are you sure you want to delete this transaction?",
    noTransactionsToShow: "No transactions to show",
    
    // Categories
    categories: {
      income: ['Salary', 'Freelance', 'Investments', 'Sales', 'Other'],
      expense: ['Food', 'Transportation', 'Housing', 'Utilities', 'Entertainment', 'Health', 'Education', 'Other']
    },
    
    // Settings
    settings: "Settings",
    settingsDesc: "Manage your account and preferences",
    accountInfo: "Account Information",
    yourInfo: "Your personal information",
    role: "Role",
    emailVerifiedLabel: "Email Verified",
    yes: "Yes",
    no: "No",
    changePassword: "Change Password",
    changePasswordDesc: "Update your access password",
    currentPassword: "Current Password",
    updating: "Updating...",
    passwordChanged: "Password updated successfully",
    
    // Admin
    adminPanel: "Admin Panel",
    adminPanelDesc: "Manage users and monitor the system",
    totalUsers: "Total Users",
    activeUsers: "Active Users",
    logins24h: "Logins (24h)",
    databaseData: "Database Data",
    records: "Records",
    users: "Users",
    registeredUsers: "Registered Users",
    lastAccess: "Last Access",
    actions: "Actions",
    active: "Active",
    inactive: "Inactive",
    never: "Never",
    accessLogs: "Access Logs",
    noAccessLogs: "No access logs",
    userDetails: "User Details",
    registrationDate: "Registration Date",
    deleteUserConfirm: "Are you sure you want to delete user",
    deleteUserWarning: "This action will also delete all their transactions and cannot be undone.",
    userDeleted: "User deleted successfully",
    
    // Sidebar
    financePanel: "Finance Panel",
    connectedAs: "Connected as",
    accounts: "Accounts",
    budgets: "Budgets",
    goalsAndDebts: "Goals and debts",
    reports: "Reports",
    receipts: "Receipts",
    import: "Import",
    importItau: "Import",
    adminPanelShort: "Admin Panel",
    
    // Errors
    invalidCredentials: "Invalid credentials",
    emailAlreadyRegistered: "Email already registered",
    passwordsDontMatch: "Passwords don't match",
    passwordTooShort: "Password must be at least 6 characters",
    invalidCode: "Invalid code",
    codeExpired: "Code expired",
    currentPasswordIncorrect: "Current password is incorrect",
    
    // Hero
    heroTitle: "Control your",
    heroHighlight: "finances",
    heroDesc: "Manage your income and expenses intelligently with WSFinances.",
    heroRegisterTitle: "Join",
    heroRegisterDesc: "Start taking control of your money today."
  },
  
  pt: {
    // Auth
    login: "Entrar",
    register: "Registrar",
    logout: "Sair",
    email: "Email",
    password: "Senha",
    confirmPassword: "Confirmar Senha",
    name: "Nome",
    forgotPassword: "Esqueceu sua senha?",
    noAccount: "Não tem conta?",
    hasAccount: "Já tem conta?",
    loginTitle: "Entre na sua conta para continuar",
    registerTitle: "Complete seus dados para se registrar",
    createAccount: "Criar Conta",
    registering: "Registrando...",
    loggingIn: "Entrando...",
    
    // Verify Email
    verifyEmail: "Verifique seu Email",
    verifyEmailDesc: "Digite o código de 6 dígitos enviado para seu email",
    verifyCode: "Código de Verificação",
    verify: "Verificar Email",
    verifying: "Verificando...",
    resendCode: "Não recebeu o código? Reenviar",
    resending: "Reenviando...",
    backToLogin: "Voltar ao login",
    emailVerified: "Email verificado com sucesso. Redirecionando...",
    codeSent: "Código reenviado. Verifique seu email.",
    
    // Forgot Password
    recoverPassword: "Recuperar Senha",
    recoverPasswordDesc: "Digite seu email para receber o código de recuperação",
    newPassword: "Nova Senha",
    sendCode: "Enviar Código",
    sending: "Enviando...",
    resetPassword: "Redefinir Senha",
    resetting: "Atualizando...",
    passwordReset: "Senha atualizada com sucesso. Redirecionando...",
    emailSentIfExists: "Se o email existir, você receberá um código de recuperação.",
    back: "Voltar",
    recoveryCode: "Código de Recuperação",
    
    // Dashboard
    dashboard: "Painel",
    welcome: "Bem-vindo",
    newTransaction: "Nova Transação",
    totalBalance: "Saldo Total",
    totalIncome: "Receita Total",
    totalExpenses: "Despesas Totais",
    incomeVsExpenses: "Receitas vs Despesas por Mês",
    expensesByCategory: "Despesas por Categoria",
    recentTransactions: "Transações Recentes",
    viewAll: "Ver todas",
    addFirstTransaction: "Adicionar primeira transação",
    createMonthlyBudget: "Criar orçamento mensal",
    realBalanceToday: "Saldo real hoje",
    incomeThisMonth: "Receitas este mês",
    expensesThisMonth: "Despesas este mês",
    availableToSpend: "Disponível para gastar",
    noDataToShow: "Sem dados para mostrar",
    noExpensesRecorded: "Sem despesas registradas",
    noTransactionsRecorded: "Sem transações registradas",
    
    // Transactions
    transactions: "Transações",
    transactionHistory: "Histórico completo de movimentos",
    searchPlaceholder: "Buscar por categoria ou descrição...",
    filterByType: "Filtrar por tipo",
    all: "Todos",
    income: "Receita",
    expense: "Despesa",
    transfer: "Transferência",
    transfers: "Transferências",
    fromAccount: "Conta origem",
    toAccount: "Conta destino",
    noLinkedAccount: "Sem conta",
    selectAccount: "Selecionar conta",
    sameAccountError: "A conta origem e destino devem ser diferentes",
    transactionTypeHelp: "Registre uma receita, despesa ou transferência entre contas",
    type: "Tipo",
    category: "Categoria",
    description: "Descrição",
    date: "Data",
    amount: "Valor",
    save: "Salvar",
    cancel: "Cancelar",
    deleteConfirm: "Tem certeza que deseja excluir esta transação?",
    noTransactionsToShow: "Sem transações para mostrar",
    
    // Categories
    categories: {
      income: ['Salário', 'Freelance', 'Investimentos', 'Vendas', 'Outros'],
      expense: ['Alimentação', 'Transporte', 'Moradia', 'Serviços', 'Entretenimento', 'Saúde', 'Educação', 'Outros']
    },
    
    // Settings
    settings: "Configurações",
    settingsDesc: "Gerencie sua conta e preferências",
    accountInfo: "Informações da Conta",
    yourInfo: "Suas informações pessoais",
    role: "Função",
    emailVerifiedLabel: "Email Verificado",
    yes: "Sim",
    no: "Não",
    changePassword: "Alterar Senha",
    changePasswordDesc: "Atualize sua senha de acesso",
    currentPassword: "Senha Atual",
    updating: "Atualizando...",
    passwordChanged: "Senha atualizada com sucesso",
    
    // Admin
    adminPanel: "Painel Admin",
    adminPanelDesc: "Gerencie usuários e monitore o sistema",
    totalUsers: "Total de Usuários",
    activeUsers: "Usuários Ativos",
    logins24h: "Logins (24h)",
    databaseData: "Dados do Banco",
    records: "Registros",
    users: "Usuários",
    registeredUsers: "Usuários Registrados",
    lastAccess: "Último Acesso",
    actions: "Ações",
    active: "Ativo",
    inactive: "Inativo",
    never: "Nunca",
    accessLogs: "Logs de Acesso",
    noAccessLogs: "Sem logs de acesso",
    userDetails: "Detalhes do Usuário",
    registrationDate: "Data de Registro",
    deleteUserConfirm: "Tem certeza que deseja excluir o usuário",
    deleteUserWarning: "Esta ação também excluirá todas as transações e não pode ser desfeita.",
    userDeleted: "Usuário excluído com sucesso",
    
    // Sidebar
    financePanel: "Painel Financeiro",
    connectedAs: "Conectado como",
    accounts: "Contas",
    budgets: "Orçamentos",
    goalsAndDebts: "Metas e dívidas",
    reports: "Relatórios",
    receipts: "Recibos",
    import: "Importar",
    importItau: "Importar",
    adminPanelShort: "Painel Admin",
    
    // Errors
    invalidCredentials: "Credenciais inválidas",
    emailAlreadyRegistered: "Email já registrado",
    passwordsDontMatch: "As senhas não coincidem",
    passwordTooShort: "A senha deve ter pelo menos 6 caracteres",
    invalidCode: "Código inválido",
    codeExpired: "Código expirado",
    currentPasswordIncorrect: "A senha atual está incorreta",
    
    // Hero
    heroTitle: "Controle suas",
    heroHighlight: "finanças",
    heroDesc: "Gerencie suas receitas e despesas de forma inteligente com WSFinances.",
    heroRegisterTitle: "Junte-se ao",
    heroRegisterDesc: "Comece a controlar seu dinheiro hoje mesmo."
  }
};

export default translations;
